// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Toish = string | ({ search?: string } & any);

export function setClientForDestination(client: string, to: Toish): Toish {
  let toCopy: typeof to;
  if (typeof to === "string") {
    if (client && !to.includes(`client=${client}`)) {
      const searchPart = to.split("?")[1];
      if (searchPart) {
        toCopy = `${to}&client=${client}`;
      } else {
        toCopy = `${to}?client=${client}`;
      }
    } else {
      toCopy = to;
    }
  } else {
    const passedSearchString = (to as { search?: string }).search;
    let searchCopy = passedSearchString;
    if (client) {
      if (passedSearchString && !passedSearchString.includes(`client=${client}`)) {
        searchCopy = `${searchCopy || ""}&client=${client}`;
      } else if (!passedSearchString) {
        searchCopy = `${searchCopy || ""}?client=${client}`;
      }
    }
    toCopy = {
      ...to,
      search: searchCopy,
    };
  }

  return toCopy;
}
